import { render, staticRenderFns } from "./OnboardingSelfieCamera.vue?vue&type=template&id=43a710d6&scoped=true"
import script from "./OnboardingSelfieCamera.vue?vue&type=script&lang=js"
export * from "./OnboardingSelfieCamera.vue?vue&type=script&lang=js"
import style0 from "./OnboardingSelfieCamera.vue?vue&type=style&index=0&id=43a710d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43a710d6",
  null
  
)

export default component.exports